type MessageType = "LINK_VIEWED" | "LIST_UPDATE_NEEDED";

interface CrossTabMessage {
  type: MessageType;
  data?: any;
}

class CrossTabCommunication {
  private channel: BroadcastChannel;
  private lastMessage: { content: string; timestamp: number } | null = null;

  constructor() {
    this.channel = new BroadcastChannel("admin-panel-updates");
  }

  sendMessage(type: MessageType, data?: any) {
    this.channel.postMessage({ type, data });
  }

  onMessage(callback: (message: CrossTabMessage) => void) {
    const handler = (event: MessageEvent) => {
      const messageContent = JSON.stringify(event.data);
      const now = Date.now();

      if (
        this.lastMessage &&
        this.lastMessage.content === messageContent &&
        now - this.lastMessage.timestamp < 100
      ) {
        return;
      }

      this.lastMessage = { content: messageContent, timestamp: now };
      callback(event.data);
    };

    this.channel.onmessage = handler;
    return () => {
      this.channel.onmessage = null;
    };
  }
}

export const crossTabCommunication = new CrossTabCommunication();
